import { Reducer } from 'redux';
import { AccessPolicy } from '@chr/online-shared-microsite-core/types';
import { UserAccessPoliciesActionTypes } from './actions';
import { IUserAccessPoliciesAction } from '../constants/userAccessPolicies';
import { Status } from '../constants/enums';

export interface IUserAccessPoliciesState {
  status: Status;
  userAccessPolicies: AccessPolicy[];
  isError: boolean;
  error: string;
}

export const initialState: IUserAccessPoliciesState = {
  status: Status.None,
  userAccessPolicies: null,
  isError: false,
  error: '',
};

// Reducer
export const userAccessPoliciesReducer: Reducer = (state = initialState, action: IUserAccessPoliciesAction): IUserAccessPoliciesState => {
  switch (action.type) {
    case UserAccessPoliciesActionTypes.USER_ACCESS_POLICIES_INIT:
      return {
        ...state,
        status: Status.Loading,
      };
    case UserAccessPoliciesActionTypes.USER_ACCESS_POLICIES_SET:
      return {
        userAccessPolicies: action.payload,
        status: Status.Successful,
        isError: false,
        error: '',
      };
    case UserAccessPoliciesActionTypes.USER_ACCESS_POLICIES_RETRIEVAL_FAILED:
      return {
        ...state,
        status: Status.Failed,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};
